<template>
  <v-menu
    v-if="event && clickEvent"
    :value="value"
    @input="$emit('input', $event)"
    :position-x="clickEvent.nativeEvent.clientX"
    :position-y="clickEvent.nativeEvent.clientY"
    absolute
    offset-y
  >
    <v-card class="popup-card">
      <div class="event-info">
        <v-icon
          @click="redirectToEditEvent()"
          class="float-right"
          style="font-size: 16px"
          >mdi-pencil</v-icon
        >
        <div
          class="event-type"
          v-bind:style="{ color: event.details.eventType.color }"
        >
          {{ event.details.eventType.name }}<br />
        </div>
        <div class="event-name">
          {{ event.details.name }}
        </div>
        <div class="event-date-time">
          {{ eventStartTime(event) }} - {{ eventEndTime(event) }}
          <small>{{ event.details.timezone }}</small>
        </div>
        <div class="event-location">
          <span>{{ event.details.venue.name }}</span>
          <small v-if="event.details.field" class="m1-2">
            -
            {{
              event.details.orgUnit.sport &&
                event.details.orgUnit.sport.fieldLabel + ": "
            }}
            {{ event.details.field }}</small
          >
        </div>
      </div>
    </v-card>
  </v-menu>
</template>
<script>
import Vue from "vue";
import moment from "moment";
import { bus } from "../../main";

export default Vue.extend({
  name: "TeamCalendarEventPopup",
  components: {},
  props: {
    clickEvent: {
      type: Object
    },
    event: {
      type: Object
    },
    value: {
      type: Boolean
    }
  },
  methods: {
    eventStartTime(event) {
      return moment(event.start).format(`h:mm A`);
    },
    eventEndTime(event) {
      return moment(event.end).format(`h:mm A`);
    },
    playerInvitesByStatus(statusName) {
      return (
        this.event.details.playerInvites.filter(
          playerInvite => playerInvite.status.name === statusName
        ) || []
      );
    },
    redirectToEditEvent() {
      bus.$emit("loadIframe", {
        url: `/event/details/${this.event.id}?hideNav=true`,
        title: "Edit Event"
      });
    }
  }
});
</script>
<style>
.popup-card {
  padding: 20px;
}
</style>
